<template>
  <div class="game">
    <Game msg="Game"/>
  </div>
</template>

<script>
  // @ is an alias to /src
  import Game from '@/components/Game.vue';

  export default {
    name: 'game',
    components: {
      Game,
    },
  };
</script>
